var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    stroke: "#FF0000",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0762 11.7956C10.0295 11.7956 9.98753 11.7816 9.9502 11.7536C9.9222 11.7163 9.9082 11.6743 9.9082 11.6276L9.7542 5.46761C9.7542 5.42094 9.7682 5.38361 9.7962 5.35561C9.83353 5.31828 9.87553 5.29961 9.9222 5.29961H11.2102C11.2569 5.29961 11.2942 5.31828 11.3222 5.35561C11.3595 5.38361 11.3782 5.42094 11.3782 5.46761L11.2242 11.6276C11.2242 11.6743 11.2055 11.7163 11.1682 11.7536C11.1402 11.7816 11.1029 11.7956 11.0562 11.7956H10.0762ZM10.4822 15.0716C10.1929 15.0716 9.95486 14.9783 9.7682 14.7916C9.59086 14.6049 9.5022 14.3669 9.5022 14.0776C9.5022 13.7883 9.59086 13.5549 9.7682 13.3776C9.95486 13.1909 10.1929 13.0976 10.4822 13.0976C10.7715 13.0976 11.0095 13.1909 11.1962 13.3776C11.3829 13.5549 11.4762 13.7883 11.4762 14.0776C11.4762 14.3669 11.3829 14.6049 11.1962 14.7916C11.0095 14.9783 10.7715 15.0716 10.4822 15.0716Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.bb6b8fc1a18e140a3ccc501bf943e23e.svg";
export { ForwardRef as ReactComponent };